import $i18n from '@/locales/i18n';
// eslint-disable-next-line import/no-cycle
import { executeFunction, isArrayNotEmpty, isEmptyButNotZero, } from '@/common/util/util';
import { __bizExtendConfig__ } from '@/common/util/const';
import isPlainObject from 'lodash/isPlainObject';
import { cnUtils } from '@cainiaofe/cn-ui';
const { pluginManager } = cnUtils || {};
if (pluginManager) {
    pluginManager?.getGlobalPlugin?.();
    pluginManager?.loadFullPlugins?.();
}
function getAllPluginSetterByComponentName(componentName) {
    let result = [];
    const plugins = pluginManager?.getPluginsByComponentName?.(componentName);
    if (isArrayNotEmpty(plugins)) {
        plugins.forEach((item) => {
            const temp = executeFunction(item?.lowCodeConfig?.getPrototypeList);
            if (isArrayNotEmpty(temp)) {
                result = [...result, ...temp];
            }
        });
    }
    return result;
}
function getBizExtendPrototype(config) {
    const { componentName, extraConfig = {} } = config || {};
    if (pluginManager && componentName) {
        const realSetters = [];
        const setterNameMap = {};
        const setters = getAllPluginSetterByComponentName(componentName);
        if (isArrayNotEmpty(setters)) {
            setters.forEach((item) => {
                const { name } = item || {};
                if (!(name && setterNameMap[name])) {
                    realSetters.push(item);
                    if (name) {
                        setterNameMap[name] = true;
                    }
                }
            });
        }
        if (isArrayNotEmpty(realSetters)) {
            return [
                {
                    name: __bizExtendConfig__,
                    title: $i18n.get({
                        id: 'ServiceExpansionConfiguration',
                        dm: '业务扩展配置',
                    }),
                    display: 'accordion',
                    extraProps: {
                        defaultCollapsed: true,
                    },
                    setter: {
                        componentName: 'ObjectSetter',
                        props: {
                            config: {
                                items: [...realSetters],
                            },
                        },
                    },
                    ...extraConfig,
                },
            ];
        }
    }
    return [];
}
function getBizExtendProps(config) {
    const { props } = config || {};
    let result;
    if (isPlainObject(props?.__bizExtendConfig__)) {
        result = { ...props.__bizExtendConfig__ };
    }
    return result;
}
/**
 * 获取包含插件扩展props的全量组件props
 * @param props
 * @param componentName
 */
function getAllComponentProps(props, componentName) {
    const extendProps = getBizExtendProps({
        componentName,
        props,
    });
    if (isPlainObject(extendProps)) {
        return { ...extendProps, ...props, __bizExtendConfig__: undefined };
    }
    else {
        return props;
    }
}
/**
 * 处理插件扩展的props
 * @param props
 * @param componentName
 */
function handleBizExtendComponentProps(props, componentName) {
    if (props) {
        const extendProps = getBizExtendProps({
            componentName,
            props,
        });
        if (isPlainObject(extendProps)) {
            Object.keys(extendProps).forEach((key) => {
                const tempV = extendProps[key];
                if (key && !isEmptyButNotZero(tempV)) {
                    props[key] = tempV;
                }
            });
            delete props.__bizExtendConfig__;
        }
    }
}
export { getBizExtendPrototype, getBizExtendProps, getAllComponentProps, handleBizExtendComponentProps, };
